import { DashboardSetupResponseDto } from "../../model/dashboard/dto/DashboardSetupResponseDto";
import { DashboardTodayResponseDto } from "../../model/dashboard/dto/DashboardTodayResponseDto";
import { GetDashboardStatsDto } from "../../model/dashboard/dto/GetDashboardStatsDto";
import { GenericWithUserId } from "../../model/shared/dto/GenericWithUserId";
import { AtiraApi } from "../AxiosClient";

export class DashboardAxios {
  static getDashoardStats(dto: GetDashboardStatsDto) {
    return AtiraApi.post(`/dashboard/stats`, dto).then(({ data }) => data);
  }

  static getSetup(dto: GenericWithUserId) {
    return AtiraApi.post<DashboardSetupResponseDto>(
      `/dashboard/setup`,
      dto,
    ).then(({ data }) => data);
  }

  static getToday(dto: GenericWithUserId) {
    return AtiraApi.post<DashboardTodayResponseDto>(
      `/dashboard/today`,
      dto,
    ).then(({ data }) => data);
  }
}
